import * as chrono from "chrono-node";
import { formatDistanceStrict } from "date-fns";

export const getDistanceTimeFromNow = (params: {
  date: Date;
  addSuffix?: boolean;
}) => {
  const { addSuffix = false, date } = params;

  const customFormatting = formatDistanceStrict(date, new Date(), {
    addSuffix,
  })
    .replace("seconds", "sec")
    .replace("second", "sec")
    .replace("minutes", "min")
    .replace("minute", "min")
    .replace(" hours", "hr")
    .replace(" hour", "hr")
    .replace(" days", "d")
    .replace(" days", "d")
    .replace(" months", "mo")
    .replace(" month", "mo")
    .replace(" years", "yr")
    .replace(" year", "yr");

  if (customFormatting.includes("0 sec")) return "Just now";

  return customFormatting;
};

export const getBrowserTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const parseDateTimeFromChronoNode = (
  str: Date | string,
  timezone: string = getBrowserTimezone(),
) => {
  if (str instanceof Date) return str;
  return chrono.parseDate(str, { timezone });
};
